import animationsHero from "../animations/animations-hero";
import { disablePageScroll, enablePageScroll } from "scroll-lock";

const popupAge = document.getElementById("popup-age");
const closePopupAge = document.getElementsByClassName("popup-age__button-succes")[0];
const popupCookie = document.getElementById('popup-cookie')

closePopupAge.onclick = function() {
  popupAge.style.display = "none";
  animationsHero();
  if ($('.preloading').length == 0) {
    enablePageScroll();
  }
  localStorage.setItem('popupAgeShown', 'true');
    
  if (localStorage.getItem('popupAgeShown') !== "true") {
    disablePageScroll();
    popupCookie.style.display = "flex";
    localStorage.setItem('popupCookieShown', 'true');
  };

  if (localStorage.getItem('popupCookieShown') !== "true") {
    popupCookie.style.display = "flex";
  };
}

if (localStorage.getItem('popupAgeShown') == "true") {
  animationsHero();
  if ($('.preloading').length == 0) {
    enablePageScroll();
  }
}

if (localStorage.getItem('popupAgeShown') !== "true") {
  popupAge.style.display = "flex";
  disablePageScroll();
};